








































































import Vue from 'vue';
import router from '../router';
import { TabType } from '../store/chatTab.store';
import ToolbarChatTab from '@/components/ToolbarChatTab.vue';
import ToolbarChat from '@/components/ToolbarChat.vue';
import MenuItem from '@/components/MenuItem.vue';
import ToolbarDefault from '@/components/ToolbarDefault.vue';
import ToolbarCampaign from '@/components/campaign/ToolbarCampaign.vue';
import PermissionService, { PermissionType } from '@/services/PermissionService';
import MenuService from '@/services/MenuService';

export default Vue.extend({
  components: { ToolbarChatTab, ToolbarChat, ToolbarDefault, ToolbarCampaign, MenuItem },
  name: 'Menu',
  props: {
    selectedChat: {
      type: Object,
    },
    route: {
      type: Object,
    },
    isMobile: {
      type: Boolean,
    },
    currentUser: {
      type: Object,
    },
  },
  data() {
    return {
      drawer: !this.isMobile,
      miniVariant: !this.isMobile,
      items: [
        {
          title: 'Ajuda',
          icon: 'mdiHelpCircle',
          routePrefix: 'help',
          open: false,
          childs: [
            {
              title: 'Fale com a gente',
              onClick: () => {
                (this as any).$intercom.show();
              },
            },
            {
              title: 'Central de ajuda',
              onClick: () => {
                window.open('http://help.omni.chat/', '_black');
              },
            },
          ],
        },
      ],
      mini: false,
    };
  },
  async mounted() {
    const menus = await MenuService.loadMenus();
    if (menus) {
      (this as any).items = [
        ...menus,
        ...this.items,
      ];
    }
  },
  watch: {
    isMobile(val) {
      if (!this.$store.state.device.mobile) {
        this.drawer = true;
      } else {
        this.drawer = false;
      }
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login');
      });
    },
  },
});
